/* eslint-disable no-use-before-define */
import React from 'react'
import {ajax, Status, getState, arrayFrom, CORP_SECTOR_LABELS as SECTOR_LABELS } from '../../twd/twd'

const state = getState('corporates.top-sectors', {
    rating: 'INVESTMENT_GRADE',
    maturity: 'LT_3'
})

export default () => {
    const [rating, setRating_] = React.useState(state.value.rating || 'INVESTMENT_GRADE')
    const setRating = React.useCallback((m) => {
        state.set({rating:m})
        setRating_(m)
    }, [])

    const [maturity, setMaturity_] = React.useState(state.value.maturity || 'LT_3')
    const setMaturity = React.useCallback((m) => {
        state.set({maturity:m})
        setMaturity_(m)
    }, [])

    const [sectors, setSectors] = React.useState([])
    const [status, setStatus] = React.useState(Status.LOADING)
    const [total, setTotal] = React.useState(0)
    const lastAbort = React.useRef()

    React.useEffect(() => {

        setTotal(null)
        setSectors([])
        ;(async () => {
            try {
                if (lastAbort.current) {
                    lastAbort.current()
                }

                setStatus(Status.LOADING)
                let {data, abort} = await ajax({
                    url: '/esb/retailservice/topMovingSectorService/getTopMovingSectorsData',
                    method: 'POST',
                    params: {
                        assetType: 'CORP',
                        rating: rating==='INVESTMENT_GRADE' ? 'IG' : 'HY',
                        maturityRange: maturityRangeMap[maturity],
                        numberOfIssuers: 3,
                    }
                })
                lastAbort.current = abort
                let a = (await data)
                lastAbort.current = null

                let rs = arrayFrom(a.topMovingSectors)
                .filter(t => t.sector)
                .map(t => ({
                    label: SECTOR_LABELS[t.sector] || t.sector,
                    total: t.tradeCount,
                    totalTradeCount: t.totalTradesCount,
                    issuers: arrayFrom(t.topMovingIssuerLists).map(a => ({
                        name: a.issuer,
                        symbol: a.symbol,
                    }))
                }))

                let r = rs[0]
                setTotal(r && r.totalTradeCount)
                setSectors(rs)

                setStatus(Status.LOADED)
            } catch(e) {
                setTotal(null)
                setStatus(Status.FAILED_TO_LOAD)
            }
        })()

        return () => {
            if (lastAbort.current) {
                lastAbort.current()
                lastAbort.current = null
            }
        }

    }, [rating, maturity])

    return {
        rating, setRating,
        maturity, setMaturity,
        status,
        sectors, total }
}

const maturityRangeMap = {
    'LT_3': '0Y-3Y',
    '3_TO_5': '3Y-5Y',
    '5_TO_10': '5Y-10Y',
    '10_TO_20': '10Y-20Y',
    'GT_20': '20Y+',
}
